'use client';

import '@ant-design/v5-patch-for-react-19';
import { ConfigProvider, theme } from 'antd';
import { px2remTransformer } from '@ant-design/cssinjs';
import { AntdRegistry } from '@ant-design/nextjs-registry';
import { useTheme } from '@/contexts/ThemeContext';

const px2rem = px2remTransformer();

const AntDesignConfig = (props: { children: React.ReactNode }) => {
  const { isDark } = useTheme();

  return (
    <AntdRegistry transformers={[px2rem]}>
      <ConfigProvider
        theme={{
          algorithm: isDark ? theme.darkAlgorithm : theme.defaultAlgorithm,
          token: {
            borderRadius: 5,
            colorPrimary: isDark ? '#161717' : '#181d84',
            fontSize: 16,
            colorBgBase: isDark ? '#161717' : '#ffffff',
            colorBgContainer: isDark ? '#1f2020' : '#ffffff',
            colorBgElevated: isDark ? '#2a2b2b' : '#ffffff',
            colorText: isDark ? '#ffffff' : '#000000',
            colorTextSecondary: isDark ? '#d1d5db' : '#6c757d',
            colorBorder: isDark ? '#374151' : '#e5e7eb',
            colorBorderSecondary: isDark ? '#4b5563' : '#d1d5db',
          },
        }}
      >
        {props.children}
      </ConfigProvider>
    </AntdRegistry>
  );
};

export default AntDesignConfig;
